<template>
	<footer class="footer">
		<h2 class="footer-title">
			联系
			<span class="text-secondary">我们</span>
		</h2>
		<div v-if="!$isMobile" class="contact">
			<div class="row contact-warp">
				<div class="col-lg-6">
					<div class="row">
						<div class="col-lg-4 qrcode">
							<img class="img-fluid" src="../assets/images/erweima.png" />
						</div>
						<div class="col-lg-7 link">
							<p class="title">北京金穗联创科技有限公司</p>
							<p class="desc">
								电话：13810264353
								<br />邮箱: &nbsp;&nbsp;admin@jinsuitech.com
								<br />地址：北京市海淀区三里河路39号
							</p>
						</div>
					</div>
				</div>

				<div class="col-lg-6">
					<div class="row">
						<div class="col-lg-6">
							<div class="row contact-form">
								<input class="form-control footer-form" type="text" v-model="msg.contactName" placeholder="姓名" />
								<input class="form-control footer-form" type="text" placeholder="手机" v-model="msg.mobile" />
								<input class="form-control footer-form" type="text" placeholder="Email" v-model="msg.email" />
								<input class="form-control footer-form" type="text" placeholder="公司" v-model="msg.companyName" />
							</div>
						</div>
						<div class="col-lg-6 message">
							<textarea class="form-control footer-form" placeholder="留言" rows="3" v-model="msg.message"></textarea>
							<button @click="sendMsg" class="btn btn-footer">提交留言</button>
						</div>
					</div>
				</div>
			</div>
			<div class="end-link">
				<img style="width: 13%;" src="../assets/images/logo.png" alt class="logo" />
				<div class="links">
					<router-link to="home" class="links-item">首页</router-link>
					<router-link to="products" class="links-item">应急装备系统</router-link>
					<router-link to="experience" class="links-item">AI安防产品</router-link>
					<router-link to="AI" class="links-item">AI解决方案</router-link>
					<router-link to="brand" class="links-item">产品动态</router-link>
					<router-link to="about" class="links-item">关于我们</router-link>
				</div>
				<div class="end-bq">版权所有©2019 jinsuitech，Inc。<a class="jingbei" href="http://www.beian.miit.gov.cn/" style="color:#676767;">京ICP备15053610号-1</a></div>
			</div>
		</div>
		<div v-if="$isMobile" class="contact-mobile">
			<a class="toggle-p" href="#link" data-target="#link" data-toggle="collapse">
				公司地址
			</a>
			<div class="link collapse" id="link">
				<p class="title">北京金穗联创科技有限公司</p>
				<p class="desc">
					电话：13810264353 &nbsp; admin@jinsuitech.com
					<br />地址：北京市海淀区三里河路39号
				</p>

			</div>
			<a class="toggle-p " href="#contact-warp" data-target="#contact-warp" data-toggle="collapse">
				在线留言
			</a>
			<div class="contact-warp collapse" id="contact-warp">
				<div class="row contact-form">
					<input class="form-control footer-form" type="text" v-model="msg.contactName" placeholder="姓名" />
					<input class="form-control footer-form" type="text" placeholder="手机" v-model="msg.mobile" />
					<input class="form-control footer-form" type="text" placeholder="Email" v-model="msg.email" />
					<input class="form-control footer-form" type="text" placeholder="公司" v-model="msg.companyName" />

					<textarea class="form-control footer-form" placeholder="留言" rows="3" v-model="msg.message"></textarea>
				</div>
				<div style="text-align:center;   padding-top: 1rem;">
					<button @click="sendMsg" class="btn btn-footer">提交留言</button>
				</div>
			</div>

			<div class="qrcode">
				<img class="img-fluid" src="../assets/images/erweima.png" />
			</div>
			<div class="links">
				<router-link to="home" class="links-item">首页</router-link>
				<router-link to="products" class="links-item">应急装备系统</router-link>
				<router-link to="experience" class="links-item">AI安防产品</router-link>
				<router-link to="AI" class="links-item">AI解决方案</router-link>
				<router-link to="brand" class="links-item">产品动态</router-link>
				<router-link to="about" class="links-item">关于我们</router-link>
			</div>
			<div class="end-bq">版权所有©2019 jinsuitech，Inc。<a class="jingbei" href="http://www.beian.miit.gov.cn/" style="color:#676767;">京ICP备15053610号-1</a></div>
		</div>
	</footer>
</template>

<script>
	import {
		CRM_URL
	} from '@/config/config.js'
	export default {
		name: "cusfooter",
		data() {
			return {
				CRM_URL,
				msg: {
					companyName: "",
					contactName: "",
					email: "",
					message: "",
					mobile: ""
				}
			};
		},
		methods: {
			sendMsg() {
				this.$api.msg.addMsg(this.msg).then(res => {
					if (res.code == 0) {
						alert("发送成功");
						this.msg = {};
					}
				});
			}
		}
	};
</script>

<style lang="scss" scoped>
	.footer-form {
		background-color: #5e5e5e;
		border: none;
		border-radius: 10px;
		color: #fff;

		&::-webkit-input-placeholder {
			/* WebKit browsers */
			color: #818181;
		}

		&:-moz-placeholder {
			/* Mozilla Firefox 4 to 18 */
			color: #818181;
		}

		&::-moz-placeholder {
			/* Mozilla Firefox 19+ */
			color: #818181;
		}

		&:-ms-input-placeholder {
			/* Internet Explorer 10+ */
			color: #818181;
		}
	}

	.btn-footer {
		background: #5e5e5e;
		color: #fff;
		border-radius: 15px;
	}
	.jingbei:hover{
		text-decoration: underline; 
	}
	.footer {
		background: #464646;
		padding: 5rem;

		h2 {
			text-align: center;
			color: #bcbcbc;
		}

		.contact {
			width: 80%;
			margin: 2rem auto 0;
			font-size: 0.9rem;
			color: #676767;

			&-warp {
				margin-bottom: 4rem;
				justify-content: space-between;
			}

			&-form {
				input {
					margin-bottom: 15px;
					max-width: 44%;
					margin-left: 15px;

					&:placeholder {
						color: #818181;
					}
				}
			}

			.message {
				display: flex;
				flex-direction: column;
				align-items: flex-end;
				justify-content: space-between;

				textarea {
					margin-bottom: 2rem;
				}
			}
		}

		.link {
			.title {
				margin-bottom: 5px;
				color: #818181;
			}
		}

		.end-link {
			display: flex;
			justify-content: space-between;
			align-items: baseline;

			.links-item {
				color: #818181;
				margin-right: 2rem;
			}
		}

		&-title {
			text-align: left;
		}
	}

	@media screen and (max-width: 1400px) {
		.footer .contact {
			&-form {
				input {
					max-width: 88%;
				}
			}

			.end-link .links-item {
				margin-right: 1rem;
			}
		}
	}

	@include media-breakpoint-down(lg) {
		.footer {
			font-size: 12px;
			padding: 2rem 1rem;
			text-align: left;
			color: #818181;

			h2 {
				text-align: left;
			}

			.contact-mobile {
				.toggle-p {
					display: block;
					color: #818181;
					border-bottom: 1px solid;
					padding-bottom: 0.5rem;
					margin-bottom: 1rem;
					text-align: left;
				}

				.qrcode {
					margin-bottom: 2rem;
				}

				.links {
					padding: 0.5rem 0;

					&-item {
						color: #818181;
						padding: 0rem 0.5rem;
						border-left: 1px solid;

						&:first-of-type {
							padding-left: 0;
							border-left: none;
						}
					}
				}

				.form-control {
					max-width: 80%;
					margin: auto;
					margin-bottom: 15px;
					font-size: 12px;
				}

				.btn {
					max-width: 80%;
					margin: auto;
					margin-bottom: 15px;
					font-size: 12px;
				}
			}
		}
	}
</style>
